import * as React from 'react';
import { connect } from 'react-redux';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Table, Row, Badge } from 'reactstrap';
import {
  ICrudGetAllAction,
  ICrudPutAction,
  TextFormat,
  JhiPagination,
  getPaginationItemsNumber,
  getSortState,
  IPaginationBaseState
} from 'react-jhipster';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import { faToolbox } from '@fortawesome/free-solid-svg-icons';
import { APP_DATE_FORMAT, APP_DATE_FORMAT_DAY, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { ITEMS_PER_PAGE } from 'app/shared/util/pagination.constants';
import { getUsers, updateUser, getAllUsers } from './user-management.reducer';
import { IRootState } from 'app/shared/reducers';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'jquery/dist/jquery.min.js';
import 'datatables.net-dt/js/dataTables.dataTables';
import 'datatables.net-dt/css/jquery.dataTables.min.css';
import $ from 'jquery';

export interface IUserManagementProps extends StateProps, DispatchProps, RouteComponentProps<{}> {}

export class UserManagement extends React.Component<IUserManagementProps, IPaginationBaseState> {
  state: IPaginationBaseState = {
    ...getSortState(this.props.location, ITEMS_PER_PAGE)
  };

  componentDidMount() {
    this.getUsers();
    this.initTable();
  }

  componentDidUpdate() {
    this.initTable();
  }

  initTable = () => {
    if (this.props.users && this.props.users.length > 0) {
      $(document).ready(() => {
        ($('#userTable') as any).DataTable({
          columnDefs: [{ targets: [0, 3, 4, 5, 6, 7], searchable: false }],
          bDestroy: true,
          // Page size and search, then page navigation above and below the table
          dom: '<"dt-bar"lf><"dt-bar"ip>rt<"dt-bar"ip>'
        });
      });
    }
  };

  sort = prop => () => {
    this.setState(
      {
        order: this.state.order === 'asc' ? 'desc' : 'asc',
        sort: prop
      },
      () => this.sortUsers()
    );
  };

  sortUsers() {
    this.props.getAllUsers();
  }

  handlePagination = activePage => this.setState({ activePage }, () => this.sortUsers());

  getUsers = () => {
    const { activePage, itemsPerPage, sort, order } = this.state;
    this.props.getAllUsers();
  };

  toggleActive = user => () => {
    this.props.updateUser({
      ...user,
      activated: !user.activated
    });
  };

  refreshPage = () => {
    window.location.reload(false);
  };

  render() {
    const { users, account, match, totalItems } = this.props;
    const userIcon = <FontAwesomeIcon style={{ margin: '3px' }} title="User" icon="user" />;
    const adminIcon = <FontAwesomeIcon style={{ margin: '3px' }} title="Admin" icon={faToolbox} />;
    return (
      <div style={{ margin: '20px' }}>
        <h2 style={{ fontSize: '26px', fontWeight: 600, textAlign: 'center' }} className="userManagement-page-heading">
          Users
          <Link style={{ margin: '5px', padding: '5px' }} to={`${match.url}/new`} className="btn btn-primary float-right jh-create-entity">
            <FontAwesomeIcon icon="plus" /> Create a new user
          </Link>
          <button
            style={{ margin: '5px', padding: '5px' }}
            className="btn btn-primary float-right jh-create-entity"
            onClick={this.refreshPage}
          >
            Refresh
          </button>
        </h2>
        <Table style={{ borderCollapse: 'collapse', width: '100%' }} striped id="userTable">
          <thead className="align-middle">
            <tr>
              <th className="hand">
                ID<FontAwesomeIcon icon="sort" />
              </th>
              <th className="hand">
                Login<FontAwesomeIcon icon="sort" />
              </th>
              <th className="hand">
                Email<FontAwesomeIcon icon="sort" />
              </th>
              <th>Profiles</th>
              <th>Role</th>
              <th className="hand">
                Created Date<FontAwesomeIcon icon="sort" />
              </th>
              <th className="hand">
                Last Modified By<FontAwesomeIcon icon="sort" />
              </th>
              <th className="hand">
                Last Modified Date<FontAwesomeIcon icon="sort" />
              </th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {users.map((user, i) => (
              <tr id={user.login} key={`user-${i}`}>
                <td style={{ margin: '2px', padding: '2px' }}>
                  <Button tag={Link} to={`${match.url}/${user.login}`} color="link" size="sm">
                    {user.id}
                  </Button>
                </td>
                <td style={{ margin: '2px', padding: '2px' }}>{user.login}</td>
                <td style={{ margin: '2px', padding: '2px' }}>{user.email}</td>
                <td style={{ margin: '2px', padding: '2px' }}>
                  {user.activated ? (
                    <Button style={{ margin: '2px', padding: '2px' }} color="success" onClick={this.toggleActive(user)}>
                      Activated
                    </Button>
                  ) : (
                    <Button style={{ margin: '2px', padding: '2px' }} color="danger" onClick={this.toggleActive(user)}>
                      Deactivated
                    </Button>
                  )}
                </td>
                <td style={{ margin: '2px', padding: '2px' }}>
                  {user.authorities
                    ? user.authorities.map(authority => {
                        if (authority === 'USER') {
                          return userIcon;
                        } else if (authority === 'ADMIN') {
                          return adminIcon;
                        }
                        return null;
                      })
                    : null}
                </td>
                <td style={{ margin: '2px', padding: '2px' }}>
                  <TextFormat value={user.createdDate} type="date" format={APP_LOCAL_DATE_FORMAT} blankOnInvalid />
                </td>
                <td>{user.lastModifiedBy}</td>
                <td style={{ margin: '2px', padding: '2px' }}>
                  <TextFormat value={user.lastModifiedDate} type="date" format={APP_LOCAL_DATE_FORMAT} blankOnInvalid />
                </td>
                <td style={{ margin: '2px', padding: '2px' }} className="text-right">
                  <div className="btn-group flex-btn-group-container">
                    <Button tag={Link} to={`${match.url}/${user.login}`} color="info" size="sm">
                      <FontAwesomeIcon icon="eye" /> <span className="d-none d-md-inline">View</span>
                    </Button>
                    <Button tag={Link} to={`${match.url}/${user.login}/edit`} color="primary" size="sm">
                      <FontAwesomeIcon icon="pencil-alt" /> <span className="d-none d-md-inline">Edit</span>
                    </Button>
                    <Button
                      tag={Link}
                      to={`${match.url}/${user.login}/delete`}
                      color="danger"
                      size="sm"
                      disabled={account.login === user.login}
                    >
                      <FontAwesomeIcon icon="trash" /> <span className="d-none d-md-inline">Delete</span>
                    </Button>
                    <Button tag={Link} to={`/reset/request`} color="dark" size="sm">
                      <span className="d-none d-md-inline">Reset</span>
                    </Button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
    );
  }
}

const mapStateToProps = (storeState: IRootState) => ({
  users: storeState.userManagement.users,
  totalItems: storeState.userManagement.totalItems,
  account: storeState.authentication.account
});

const mapDispatchToProps = { getUsers, updateUser, getAllUsers };

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(UserManagement);
